module.exports = __webpack_public_path__ + "img/1-2.94f59d35.jpg";